import {isValidPhoneNumber as isValidPhone} from 'react-phone-number-input';

export function isValidPhoneNumber(phone: string, countryCode: string) {
  return isValidPhone(`${countryCode}${phone}`);
}
